import React, { createContext, useContext, useMemo } from 'react';
import { node, string } from 'prop-types';
import { getIsMobileByUA, getIsTabletByUA } from 'utils/ua';

const ViewContext = createContext(null);
export const useViewContext = () => useContext(ViewContext);

function ViewContextProvider({ serverUserAgent, children }) {
  const ua = useMemo(
    () =>
      typeof window !== 'undefined' ? navigator.userAgent : serverUserAgent,
    []
  );
  const isMobileView = getIsMobileByUA(ua);
  const isTabletView = getIsTabletByUA(ua);

  return (
    <ViewContext.Provider value={{ isMobileView, isTabletView }}>
      {children}
    </ViewContext.Provider>
  );
}

ViewContextProvider.propTypes = {
  serverUserAgent: string,
  children: node,
};

export default ViewContextProvider;
